<app-product-header-card-widget
    [formControl]="formControl"
    [loadingSig]="this.options.formState.detailComponent.loading()"
    [form]="form"
    [product]="model"
    [key]="this.key"
    (onDelete)="onDelete.emit($event)"
/>
